import { render, staticRenderFns } from "./recommendCourse.vue?vue&type=template&id=7dfa7327&scoped=true"
import script from "./recommendCourse.vue?vue&type=script&lang=js"
export * from "./recommendCourse.vue?vue&type=script&lang=js"
import style0 from "./recommendCourse.vue?vue&type=style&index=0&id=7dfa7327&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfa7327",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dfa7327')) {
      api.createRecord('7dfa7327', component.options)
    } else {
      api.reload('7dfa7327', component.options)
    }
    module.hot.accept("./recommendCourse.vue?vue&type=template&id=7dfa7327&scoped=true", function () {
      api.rerender('7dfa7327', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/recommendCourse.vue"
export default component.exports